import { render, staticRenderFns } from "./multiAdjustPriceDialog.vue?vue&type=template&id=81f57148&scoped=true"
import script from "./multiAdjustPriceDialog.vue?vue&type=script&lang=js"
export * from "./multiAdjustPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f57148",
  null
  
)

export default component.exports